import * as styles from 'styles/pages/Styleguide.css'
import * as cn from 'classnames'
import ModuleWrapper from 'components/features/pfm/ModuleWrapper/ModuleWrapper'
import { Caption } from 'components/atoms/Text'

const SGModules = () => (
  <section className={ cn(styles.sgSection, styles.sgModules) }>
    <ul>
      <li>
        <ModuleWrapper title='Debts' card={ false }>
          <Caption>Module Content goes here</Caption>
        </ModuleWrapper>
        <Caption text='Regular Module' />
      </li>
      <li>
        <ModuleWrapper title='Debts'>
          <Caption>Module Content goes here</Caption>
        </ModuleWrapper>
        <Caption text='Card Module' />
      </li>
      <li>
        <ModuleWrapper title='Assets' anchor='dashboard_debts' card>
          <Caption>Module Content goes here</Caption>
        </ModuleWrapper>
        <Caption text='Module With Insight' />
      </li>
    </ul>
  </section>
)

export default SGModules
